module.exports = __webpack_public_path__ + "static/media/Earth.51f3f975.svg";